<template>
  <section v-show="pupUpIsVisible" class="popup">
    <div class="alert shadow-sm p-1" :class="`alert-${bodyPopUps.typeClass}`">
      <div class="d-flex justify-content-between">
        <div class="box-message">
          <small class="p-2">{{ bodyPopUps.message }}</small>
        </div>
        <div class="pl-2">
          <button @click="closeAlert()" class="btn btn-sm">
            <i class="icon icon-close"></i>
          </button>
        </div>
      </div>
      <div class="progress" :style="`width: ${length_bar}%`"></div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "PopUp",
  data() {
    return {
      isVisible: true,
      length_bar: 0,
    };
  },
  computed: {
    ...mapGetters("alertes", ["pupUpIsVisible", "bodyPopUps"]),
  },
  watch: {
    pupUpIsVisible() {
      if (this.pupUpIsVisible) {
        let interval = setInterval(() => {
          this.changeLengthBar();
        }, 50);
        setTimeout(() => {
          this.closeAlertAll(interval);
          // clearInterval(interval);
          this.length_bar = 0;
        }, 5000);
      }
    },
  },

  methods: {
    ...mapActions("alertes", ["closeAlert"]),
    closeAlertAll(interval) {
      this.closeAlert();
      clearInterval(interval);
    },
    changeLengthBar() {
      this.length_bar += 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes dissolve {
  0% {
    opacity: 1;
  }
  85% {
    opacity: 0.9;
  }
  100% {
    opacity: 0;
  }
}
.popup {
  //   width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  z-index: 10000;
  margin-top: 85vh;
  margin-left: 33%;
  @media (max-width: 765px) {
    margin-top: 5vh;
    margin-left: 2px;
    .alert {
      width: 70vw;
    }
  }

  .alert {
    animation: dissolve 5000ms;
    padding: 2px !important;
    min-width: 300px;
    max-width: 500px;
    .box-message {
      max-width: 320px;
    }
  }
  .progress {
    border-radius: 4px;
    height: 4px;
  }

  .alert-success {
    .progress {
      background-color: #84cda6;
    }
    i {
      background: #155724;
    }
  }
  .alert-danger {
    .progress {
      background-color: #fe7474;
    }
    i,
    .progress {
      background: #721c24;
    }
  }
  .alert-secondary {
    color: #666;
    .progress {
      background-color: #ccc;
    }
    i,
    .progress {
      background: #444;
    }
  }
}
.icon-close {
  height: 20px;
  width: 20px;
}
</style>
